import React from 'react'
import { EditorState} from 'draft-js';
import Web from './web/Web';
import Calendar from './Calendar';

function MyAtomicComponent(props) {

  const entityKey = props.block.getEntityAt(0);
  const entity = props.contentState.getEntity(entityKey);
  const data = entity.getData();

  const update = (data) =>{

    const contentState = props.editorState.getCurrentContent();
    const entityKey = props.block.getEntityAt(0);
    const newContentState = contentState.replaceEntityData(entityKey, data);

    // Push the new content state into the editor
    const newEditorState = EditorState.push(props.editorState, newContentState, 'apply-entity');
    props.blockProps.setEditorState(newEditorState);

  } 

  const renderWidget = ()=>{
    switch(data.type){
      case "calendar":
        return <Calendar initialData={data} update={update} editing={false} edit={()=>props.blockProps.editWidget(entityKey, data)} />
      default:
        return <Web initialData={data} update={update} editing={false} edit={()=>props.blockProps.editWidget(entityKey, data)} />
    }
  }

  return (
    <>
    {renderWidget()}
    </>
  );

}

export default MyAtomicComponent